<div class="row row1">
  <div class="col-sm-12 header-container">
    <h2>My Profile</h2>
  </div>
</div>

<div class="row flex-row">
  <!--<div class="col-sm-6 col-md-4 flex-col">
    <div class="panel panel-card panel-split">
      <div class="split-left">
        <i class="fa fa-pen-square profile-icons"></i>
      </div>
      <div class="split-right">
        <div class="split-text">
          <h3 class="split-title">Manage Accounts</h3>
          <p>Add, Edit or Remove accounts in your profile</p>
        </div>
        <div class="link-out">
          <br/>
          <a class="btn btn-link-directional" title="GO" routerLink="/MyProfile/ManageAccounts">GO<i class="fa fa-chevron-right icon-spacing-left"></i></a>
        </div>
      </div>
    </div>
  </div>-->
  <div class="col-sm-6 col-md-4 flex-col">
    <div class="panel panel-card panel-split">
      <div class="split-left">
        <i class="fa fa fa-bell profile-icons"></i>
      </div>
      <div class="split-right">
        <div class="split-text">
          <h3 class="split-title">Alerts &amp; Communications</h3>
          <p>View and edit alerts and notifications that inform you about your accounts.</p>
        </div>
        <div class="link-out">
          <a  class="btn btn-link-directional" title="GO" routerLink="/MyProfile/Alerts">GO<i class="fa fa-chevron-right icon-spacing-left"></i></a>
        </div>
      </div>
    </div>
  </div>
  <div class="col-sm-6 col-md-4 flex-col">
    <div class="panel panel-card panel-split">
      <div class="split-left">
        <i class="fa fa-user-edit profile-icons"></i>
      </div>
      <div class="split-right">
        <div class="split-text">
          <h3 class="split-title">Contact Information</h3>
          <p>View and edit the various ways we get in touch with you about your service.</p>
        </div>
        <div class="link-out">
          <a class="btn btn-link-directional" title="GO" routerLink="/MyProfile/ContactInfo">GO<i class="fa fa-chevron-right icon-spacing-left"></i></a>
        </div>
      </div>
    </div>
  </div>
  <div class="col-sm-6 col-md-4 flex-col">
    <div class="panel panel-card panel-split">
      <div class="split-left">
        <i class="fas fa-shield-alt profile-icons"></i>
      </div>
      <div class="split-right">
        <div class="split-text">
          <h3 class="split-title">Log In Information</h3>
          <p >View and edit the information you use to login to your OMNIA profile.</p>
        </div>
        <div class="link-out">
          <br />
          <a class="btn btn-link-directional" title="GO" routerLink="/MyProfile/LoginInfo">GO<i class="fa fa-chevron-right icon-spacing-left"></i></a>
        </div>
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/profile-container/profile-container.component.html